/**
 * Orden operativo del módulo Asistente Laboral y REPSE.
 * Usado en sidebar (secciones), banner de flujo y manual PDF.
 */
export const LABORAL_FLUJO_SECTIONS = [
  {
    id: "base",
    title: "1. Base del cliente",
    subtitle: "Datos maestros y registros patronales",
  },
  {
    id: "expediente",
    title: "2. Expediente de trabajadores",
    subtitle: "Catálogo e inscripciones",
  },
  {
    id: "repse",
    title: "3. Obra y REPSE",
    subtitle: "Contratos, asignación y bitácora",
  },
  {
    id: "reportes",
    title: "4. Reportes IMSS",
    subtitle: "Cuatrimestrales y confronta emisiones",
  },
];

/** Pasos operativos (sin Panel ni Ayuda). Cliente vía pestaña Datos Maestros. */
export const LABORAL_FLUJO_PASOS = [
  {
    step: 1,
    sectionId: "base",
    path: "/registros-patronales-certificados",
    label: "Registros patronales",
    shortLabel: "Patronales",
    hint: "Matriz y obras: registro patronal, certificado e IDSE.",
  },
  {
    step: 2,
    sectionId: "expediente",
    path: "/catalogo-trabajadores",
    label: "Catálogo de trabajadores",
    shortLabel: "Catálogo",
    hint: "Alta manual, importación Excel/PDF o desde SAT.",
  },
  {
    step: 2,
    sectionId: "expediente",
    path: "/expedientes-laborales",
    label: "Expedientes laborales",
    shortLabel: "Expedientes",
    hint: "Contratos, carta SAT, nóminas y renuncia por trabajador.",
  },
  {
    step: 3,
    sectionId: "repse",
    path: "/control-repse",
    label: "Control REPSE",
    shortLabel: "REPSE",
    hint: "Registre obra/contrato, altas/bajas y asigne trabajadores.",
  },
  {
    step: 4,
    sectionId: "reportes",
    path: "/confronta-trabajadores-imss",
    label: "Declaraciones cuatrimestrales",
    shortLabel: "Cuatrimestrales",
    hint: "Genere SISUB / ICSOE por obra y periodo.",
  },
  {
    step: 5,
    sectionId: "reportes",
    path: "/confronta-emisiones-imss",
    label: "Confronta IMSS",
    shortLabel: "Confronta IMSS",
    hint: "Compare descarga IMSS contra su catálogo interno.",
  },
];

const _pathToStep = new Map(
  LABORAL_FLUJO_PASOS.map((p) => [p.path.split("?")[0], p]),
);

export function getLaboralFlujoPasoForPath(pathname, search = "") {
  const path = String(pathname || "").split("?")[0];
  if (path === "/laboral/inicio") {
    return {
      ...LABORAL_PANEL_CONTROL_PASO,
      path: "/laboral/inicio",
    };
  }
  const full = search ? `${path}?${String(search).replace(/^\?/, "")}` : path;
  if (_pathToStep.has(path)) return _pathToStep.get(path);
  for (const paso of LABORAL_FLUJO_PASOS) {
    if (paso.path === full || path.startsWith(`${paso.path.split("?")[0]}/`)) return paso;
  }
  return null;
}

export function getLaboralFlujoSection(sectionId) {
  return LABORAL_FLUJO_SECTIONS.find((s) => s.id === sectionId) || null;
}

const FLUJO_STEPPER_ICON = {
  1: "shield",
  2: "users",
  3: "briefcase",
  4: "compare",
  5: "compare",
  6: "panel",
};

/** Panel de control al cierre del flujo (paso 6). */
export const LABORAL_PANEL_CONTROL_PASO = {
  step: 6,
  sectionId: "reportes",
  label: "Panel de control laboral",
  shortLabel: "Inicio",
  hint: "Revise alertas críticas, preventivas, confronta SAT y el periodo cuatrimestral.",
  paths: ["/laboral/inicio"],
  iconKey: "panel",
};

/** Pasos únicos para el stepper visual del flujo operativo laboral. */
export function getLaboralFlujoStepperItems() {
  const seen = new Set();
  const items = [];
  for (const paso of LABORAL_FLUJO_PASOS) {
    const key = `step-${paso.step}`;
    if (seen.has(key)) continue;
    seen.add(key);
    items.push({
      step: paso.step,
      label: paso.label,
      shortLabel: paso.shortLabel,
      hint: paso.hint,
      paths: [paso.path],
      iconKey: FLUJO_STEPPER_ICON[paso.step] || "panel",
    });
  }
  items.push(LABORAL_PANEL_CONTROL_PASO);
  return items;
}
